import React, { useMemo, useState } from 'react';

import { string } from 'yup';

import { FormSection } from 'src/app/components/lib/form';
import { Input } from 'src/app/components/lib/input';
import { Modal } from 'src/app/components/lib/modal';

type SendTestEmailModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSendClick: (sendTo: string) => void;
};

const yupEmailSchema = string().email().required();

export function SendTestEmailModal({ onSendClick, isOpen, onClose }: SendTestEmailModalProps) {
  const [sendTo, setSendTo] = useState('');

  const isValidEmail = useMemo(() => yupEmailSchema.isValidSync(sendTo), [sendTo]);
  return (
    <Modal
      Content={
        <FormSection>
          <Input
            label='Send test email to:'
            labelPlacement='top'
            value={sendTo}
            onChange={(e) => setSendTo(e.target.value)}
          />
        </FormSection>
      }
      open={isOpen}
      primaryActions={[
        {
          label: 'Send',
          onClick: () => onSendClick(sendTo),
          disabled: !isValidEmail,
        },
      ]}
      title='Send preview'
      onClose={onClose}
    />
  );
}
